import * as React from "react";
import { ErrorScreen } from "../routes/ErrorScreen";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error?: Error;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error("Uncaught error:", error, info);
  }

  render() {
    const showErrorDescription = process.env.SHOW_ERRORS_IN_ERROR_BOUNDARY === "true";
    const error = showErrorDescription ? this.state.error : undefined;

    if (this.state.error) {
      return <ErrorScreen error={error} />;
    }

    return this.props.children;
  }
}
